import { render, staticRenderFns } from "./list-price-switch.vue?vue&type=template&id=42135643&"
import script from "./list-price-switch.vue?vue&type=script&lang=js&"
export * from "./list-price-switch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports